module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEXMAAD////uqKgwmpO8AAAAJUlEQVRIx2OAAtVQGHCAiozKjMqMyozKjMqMyozKjMqMygx/GQDewE72bs4ZRQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/peru.png
// module id = 634
// module chunks = 0